
import { defineComponent } from 'vue'
import EmailTechpacks from './EmailTechpacks.vue'

export default defineComponent({
  name: 'ShareTechpackDialog',
  emits: ['hide-share-techpack-dialog'],
  props: {
    show: {
      type: Boolean,
      default: false
    },
    selectedProducts: {
      type: Array
    }
  },
  components: {
    EmailTechpacks
  }
})
